/**
 * @generated SignedSource<<014e1bcc152612180dac48f9e699e84f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CandidateAddQuery$variables = Record<PropertyKey, never>;
export type CandidateAddQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CandidateAdd_query">;
};
export type CandidateAddQuery = {
  response: CandidateAddQuery$data;
  variables: CandidateAddQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateAddQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateAdd_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CandidateAddQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ede230ec3aae63e2c8eb11e5cebb843d",
    "id": null,
    "metadata": {},
    "name": "CandidateAddQuery",
    "operationKind": "query",
    "text": "query CandidateAddQuery {\n  ...CandidateAdd_query\n}\n\nfragment CandidateAdd_query on Query {\n  company: companyDomainName {\n    id\n    ...CompanyLogo_company\n  }\n}\n\nfragment CompanyLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f527d19f0625c9b4e2cffea367c5594";

export default node;
